import { categories } from 'assets/category-selector-data';
import { branches } from 'assets/json/branch-selector-data';
import { of } from 'rxjs';
import { FeatureToggleService } from '@sc/pas-common';
var ListSetService = /** @class */ (function () {
    function ListSetService(featureToggleService) {
        this.featureToggleService = featureToggleService;
    }
    ListSetService.prototype.branchSelectorData = function () {
        var _this = this;
        var branchData = branches.branches;
        if (this.featureToggleService.features) {
            branchData = branchData.filter(function (branch) { return !_this.featureToggleService.features.find(function (feature) { return feature.id === branch.hideForFeatureToggle; }); });
            branchData = branchData.filter(function (branch) { return !branch.showForFeatureToggle || (branch.showForFeatureToggle && _this.featureToggleService.features.find(function (feature) { return feature.id === branch.showForFeatureToggle; })); });
        }
        else {
            branchData = branchData.filter(function (branch) { return !branch.showForFeatureToggle; });
        }
        return of(branchData);
    };
    ListSetService.prototype.categorySelectorData = function () {
        return of(categories);
    };
    return ListSetService;
}());
export { ListSetService };
